import { combineReducers } from 'redux';

import apiCallReducer from './apiCall';
import appReducer from './app';
import contractGeneratorReducer from './contractGenerator';

const rootReducer = combineReducers({
	apiCall: apiCallReducer,
	app: appReducer,
	contractGenerator: contractGeneratorReducer
});

export default rootReducer;
